export {default as BackgroundAcc} from './BackgroundAcc'
export {default as FavIconAcc} from './FavIconAcc'
export {default as FontAcc} from './FontAcc'
export {default as BrandingAcc} from './BrandingAcc'
export {default as SeoAcc} from './SeoAcc'
export {default as AvatarAcc} from './AvatarAcc'
export {default as LinkAcc} from './LinkAcc'